import { MOBILE_BREAK_POINT } from 'library/globals';
import { useMediaQuery } from 'react-responsive';

const useIsMobile = () => {
    const isMobileQuery = useMediaQuery({ query: `(max-width: ${MOBILE_BREAK_POINT}px)` });
    return isMobileQuery;
};

export default useIsMobile;
